export default __webpack_public_path__ + "./assets/img/reasons-1-7a2fc0aec9674c4af459b3fbb58bf5d2.png";